import { render, staticRenderFns } from "./StatChartSunwheel.vue?vue&type=template&id=8a368fce&"
import script from "./StatChartSunwheel.vue?vue&type=script&lang=js&"
export * from "./StatChartSunwheel.vue?vue&type=script&lang=js&"
import style0 from "./StatChartSunwheel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/timefly-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a368fce')) {
      api.createRecord('8a368fce', component.options)
    } else {
      api.reload('8a368fce', component.options)
    }
    module.hot.accept("./StatChartSunwheel.vue?vue&type=template&id=8a368fce&", function () {
      api.rerender('8a368fce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StatChartSunwheel.vue"
export default component.exports